import axios from "axios";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Api_Url } from "../../../config/config";
import { DatePicker } from "antd";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { InfoToast } from "../../ToastComponent";

const ActivityFilterPage = ({ parentFunctionLeads }) => {
  const [focusedClientId, setFocusedClientId] = useState(false);
  const [inputValueClientId, setInputValueClientId] = useState(null);
  const [branch, setBranch] = useState([]);
  const [activity, setActivity] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [inputSourceTeamMembers, setInputSourceTeamMembers] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState("");

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#ff9b44" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "#ff9b44",
      },
    }),
  };

  // console.log("first",userId)

  useEffect(()=>{
    const id = JSON.parse(sessionStorage.getItem('user'))?.id;
    setUserId(id)
  },[])

  const handleDataBranchFunc = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setBranch([{ id: "all", name: "Select All" }, ...response?.data?.data]);
    } catch (error) {
      console.error("branch data error", error);
    }
  };

  const handleDataActivityFunc = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Activity?PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setActivity([{ id: "all", name: "Select All" }, ...response?.data?.data]);
    } catch (error) {
      console.error("activity data error", error);
    }
  };

  const handleTeamMembersFunc = async () => {
    try {
      const userId = JSON.parse(sessionStorage.getItem("user"))?.id;
      const response = await axios.get(
        `${Api_Url}api/v1/Team/${userId}/team-members`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setTeamMembers([
        { id: "all", firstName: "Select", lastName: "All" },
        ...response?.data?.data,
      ]);
    } catch (error) {
      console.error("Team Members Api Error", error);
    }
  };

  const fetchAllData = async () => {
    try {
      const response = await axios.get(`${Api_Url}api/v1/ActivityLog`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });
      parentFunctionLeads(response.data.data);
    } catch (error) {
      console.error("Error fetching all data", error);
    }
  };

  useEffect(() => {
    handleDataBranchFunc();
    handleDataActivityFunc();
    handleTeamMembersFunc();
  }, []);

  const handleBranchChange = (selectedOption) => {
    setInputValueClientId(selectedOption);
  };

  const handleActivityChange = (selectedOption) => {
    setSelectedActivity(selectedOption);
  };

  const handleTeamMembers = (selectedOption) => {
    setInputSourceTeamMembers(selectedOption);
  };

  const handleFilterApply = async () => {
    const filters = [];
    if (inputValueClientId && inputValueClientId.value !== "all") {
      filters.push(`BranchId=${inputValueClientId.value}`);
    }
    if (inputSourceTeamMembers && inputSourceTeamMembers.value !== "all") {
      filters.push(`UserId=${userId}&EmployeeId=${inputSourceTeamMembers.value}`);
    }
    if (!inputSourceTeamMembers) {
      filters.push(`UserId=${userId}`);
    }
    if (selectedActivity && selectedActivity.value !== "all") {
      filters.push(`ActivityId=${selectedActivity.value}`);
    }
    if (startDate) {
      const normalizedStartDate = moment(startDate).format("YYYY-MM-DD");
      filters.push(`StartDate=${normalizedStartDate}`);
    }
    if (endDate) {
      const normalizedEndDate = moment(endDate).format("YYYY-MM-DD");
      filters.push(`EndDate=${normalizedEndDate}`);
    }

    // if (filters.length === 0) {
    //   InfoToast("Please select at least one filter to apply.");
    //   return;
    // }

    try {
      const queryString = `?${filters.join("&")}`;
      parentFunctionLeads([]);
      const response = await axios.get(
        `${Api_Url}api/v1/ActivityLog/myteam${queryString}&PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      console.log("tt",response.data.data)
      parentFunctionLeads(response.data.data);
    } catch (error) {
      console.error("Error filtering activities", error);
    }
  };

  const handleDownload = async () => {
    const filters = [];
    // Add other filters first
    if (inputValueClientId && inputValueClientId.value !== "all") {
      filters.push(`BranchId=${inputValueClientId.value}`);
    }
    if (inputSourceTeamMembers && inputSourceTeamMembers.value !== "all") {
      filters.push(`EmployeeId=${inputSourceTeamMembers.value}`);
    }
    if (selectedActivity && selectedActivity.value !== "all") {
      filters.push(`ActivityId=${selectedActivity.value}`);
    }
    if (startDate) {
      const normalizedStartDate = moment(startDate).format("YYYY-MM-DD");
      filters.push(`StartDate=${normalizedStartDate}`);
    }
    if (endDate) {
      const normalizedEndDate = moment(endDate).format("YYYY-MM-DD");
      filters.push(`EndDate=${normalizedEndDate}`);
    }
    // Add UserId filter last
    if (!inputSourceTeamMembers) {
      filters.push(`UserId=${userId}`);
    }
    
    try {
      const queryString = `?${filters.join("&")}`;
      const response = await axios.get(
        `${Api_Url}api/v1/ActivityLog/download/excel/myteam${queryString}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
          responseType: 'blob', // important to get response as blob
        }
      );
      
      // Create a link element
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Specify the file name
      link.setAttribute('download', 'activity_log.xlsx');
      
      // Append to the DOM
      document.body.appendChild(link);
      
      // Trigger the download
      link.click();
      
      // Clean up and remove the link
      link.parentNode.removeChild(link);
      
      // parentFunctionLeads(response.data.data);
    } catch (error) {
      console.error("Error filtering activities", error);
    }
};

  return (
    <>
      <div className="row filter-row">
        <div className="col-sm-6 col-md-3">
          <div
            className={
              focusedClientId
                ? "input-block form-focus focused"
                : "input-block form-focus"
            }
          >
            <Select
              options={branch.map((b) => ({ value: b.id, label: b.name }))}
              value={inputValueClientId}
              onChange={handleBranchChange}
              onFocus={() => setFocusedClientId(true)}
              onBlur={() =>
                setFocusedClientId(inputValueClientId ? true : false)
              }
              placeholder="Select Branch"
              styles={customStyles}
            />
          </div>
        </div>
        <div className="col-sm-6 col-md-3">
          <div
            className={
              focusedClientId
                ? "input-block form-focus focused"
                : "input-block form-focus"
            }
          >
            <Select
              options={activity.map((a) => ({ value: a.id, label: a.name }))}
              value={selectedActivity}
              onChange={handleActivityChange}
              onFocus={() => setFocusedClientId(true)}
              onBlur={() => setFocusedClientId(selectedActivity ? true : false)}
              placeholder="Select Activity"
              styles={customStyles}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <div className="input-block form-focus select-focus">
            <Select
              options={teamMembers.map((s) => ({
                value: s.id,
                label: `${s.firstName} ${s.lastName}`,
              }))}
              onChange={handleTeamMembers}
              placeholder="Select Team Members"
              styles={customStyles}
              value={inputSourceTeamMembers}
            />
          </div>
        </div>
        <div className="col-sm-6 col-md-3">
          <div className="input-block form-focus select-focus">
            <DatePicker
              value={startDate ? moment(startDate) : null}
              onChange={(date) => setStartDate(date ? date.toDate() : null)}
              format="DD/MM/YYYY"
              placeholder="Start Date"
              className="form-control"
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <div className="input-block form-focus select-focus">
            <DatePicker
              value={endDate ? moment(endDate) : null}
              onChange={(date) => setEndDate(date ? date.toDate() : null)}
              format="DD/MM/YYYY"
              placeholder="End Date"
              className="form-control"
            />
          </div>
        </div>
        <div className="col-sm-6 col-md-3">
          <button
            className="btn btn-success btn-block w-100"
            onClick={handleFilterApply}
          >
            Apply Filter
          </button>
        </div>
        <div className="col-sm-6 col-md-3">
          <button
            className="btn btn-primary btn-block w-100"
            onClick={handleDownload}
          >
            Download
          </button>
        </div>
      </div>
    </>
  );
};

export default ActivityFilterPage;






// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import Select from "react-select";
// import { Api_Url } from "../../../config/config";
// import { DatePicker } from "antd";
// import moment from "moment";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { InfoToast } from "../../ToastComponent";

// const ActivityFilterPage = ({ parentFunctionLeads }) => {
//   const [focusedClientId, setFocusedClientId] = useState(false);
//   const [inputValueClientId, setInputValueClientId] = useState(null);
//   const [branch, setBranch] = useState([]);
//   const [activity, setActivity] = useState([]);
//   const [selectedActivity, setSelectedActivity] = useState(null);
//   const [inputSourceTeamMembers, setInputSourceTeamMembers] = useState(null);
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   const [teamMembers, setTeamMembers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [userId, setUserId] = useState("");

//   const customStyles = {
//     option: (provided, state) => ({
//       ...provided,
//       backgroundColor: state.isFocused ? "#ff9b44" : "#fff",
//       color: state.isFocused ? "#fff" : "#000",
//       "&:hover": {
//         backgroundColor: "#ff9b44",
//       },
//     }),
//   };

//   // console.log("first",userId)

//   useEffect(()=>{
//     const id = JSON.parse(sessionStorage.getItem('user'))?.id;
//     setUserId(id)
//   },[])

//   const handleDataBranchFunc = async () => {
//     try {
//       const response = await axios.get(
//         `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=100`,
//         {
//           headers: {
//             Authorization: `Bearer ${
//               JSON.parse(sessionStorage.getItem("user")).accessToken
//             }`,
//           },
//         }
//       );
//       setBranch([{ id: "all", name: "Select All" }, ...response?.data?.data]);
//     } catch (error) {
//       console.error("branch data error", error);
//     }
//   };

//   const handleDataActivityFunc = async () => {
//     try {
//       const response = await axios.get(
//         `${Api_Url}api/v1/Activity?PageNumber=1&PageSize=100`,
//         {
//           headers: {
//             Authorization: `Bearer ${
//               JSON.parse(sessionStorage.getItem("user")).accessToken
//             }`,
//           },
//         }
//       );
//       setActivity([{ id: "all", name: "Select All" }, ...response?.data?.data]);
//     } catch (error) {
//       console.error("activity data error", error);
//     }
//   };

//   const handleTeamMembersFunc = async () => {
//     try {
//       const userId = JSON.parse(sessionStorage.getItem("user"))?.id;
//       const response = await axios.get(
//         `${Api_Url}api/v1/Team/${userId}/team-members`,
//         {
//           headers: {
//             Authorization: `Bearer ${
//               JSON.parse(sessionStorage.getItem("user")).accessToken
//             }`,
//           },
//         }
//       );
//       setTeamMembers([
//         { id: "all", firstName: "Select", lastName: "All" },
//         ...response?.data?.data,
//       ]);
//     } catch (error) {
//       console.error("Team Members Api Error", error);
//     }
//   };

//   const fetchAllData = async () => {
//     try {
//       const response = await axios.get(`${Api_Url}api/v1/ActivityLog`, {
//         headers: {
//           Authorization: `Bearer ${
//             JSON.parse(sessionStorage.getItem("user")).accessToken
//           }`,
//         },
//       });
//       parentFunctionLeads(response.data.data);
//     } catch (error) {
//       console.error("Error fetching all data", error);
//     }
//   };

//   useEffect(() => {
//     handleDataBranchFunc();
//     handleDataActivityFunc();
//     handleTeamMembersFunc();
//   }, []);

//   const handleBranchChange = (selectedOption) => {
//     setInputValueClientId(selectedOption);
//   };

//   const handleActivityChange = (selectedOption) => {
//     setSelectedActivity(selectedOption);
//   };

//   const handleTeamMembers = (selectedOption) => {
//     setInputSourceTeamMembers(selectedOption);
//   };

//   const handleFilterApply = async () => {
//     const filters = [];
//     if (inputValueClientId && inputValueClientId.value !== "all") {
//       filters.push(`BranchId=${inputValueClientId.value}`);
//     }
//     if (inputSourceTeamMembers && inputSourceTeamMembers.value !== "all") {
//       filters.push(`EmployeeId=${inputSourceTeamMembers.value}`);
//     }
//     if (!inputSourceTeamMembers) {
//       filters.push(`UserId=${userId}`);
//     }
//     if (selectedActivity && selectedActivity.value !== "all") {
//       filters.push(`ActivityId=${selectedActivity.value}`);
//     }
//     if (startDate) {
//       const normalizedStartDate = moment(startDate).format("YYYY-MM-DD");
//       filters.push(`StartDate=${normalizedStartDate}`);
//     }
//     if (endDate) {
//       const normalizedEndDate = moment(endDate).format("YYYY-MM-DD");
//       filters.push(`EndDate=${normalizedEndDate}`);
//     }

//     // if (filters.length === 0) {
//     //   InfoToast("Please select at least one filter to apply.");
//     //   return;
//     // }

//     try {
//       const queryString = `?${filters.join("&")}`;
//       parentFunctionLeads([]);
//       const response = await axios.get(
//         `${Api_Url}api/v1/ActivityLog/myteam${queryString}&PageNumber=1&PageSize=100`,
//         {
//           headers: {
//             Authorization: `Bearer ${
//               JSON.parse(sessionStorage.getItem("user")).accessToken
//             }`,
//           },
//         }
//       );
//       parentFunctionLeads(response.data.data);
//     } catch (error) {
//       console.error("Error filtering activities", error);
//     }
//   };

//   const handleDownload = async () => {
//     const filters = [];
//     // Add other filters first
//     if (inputValueClientId && inputValueClientId.value !== "all") {
//       filters.push(`BranchId=${inputValueClientId.value}`);
//     }
//     if (inputSourceTeamMembers && inputSourceTeamMembers.value !== "all") {
//       filters.push(`EmployeeId=${inputSourceTeamMembers.value}`);
//     }
//     if (selectedActivity && selectedActivity.value !== "all") {
//       filters.push(`ActivityId=${selectedActivity.value}`);
//     }
//     if (startDate) {
//       const normalizedStartDate = moment(startDate).format("YYYY-MM-DD");
//       filters.push(`StartDate=${normalizedStartDate}`);
//     }
//     if (endDate) {
//       const normalizedEndDate = moment(endDate).format("YYYY-MM-DD");
//       filters.push(`EndDate=${normalizedEndDate}`);
//     }
//     // Add UserId filter last
//     if (!inputSourceTeamMembers) {
//       filters.push(`UserId=${userId}`);
//     }
    
//     try {
//       const queryString = `?${filters.join("&")}`;
//       const response = await axios.get(
//         `${Api_Url}api/v1/ActivityLog/download/excel/myteam${queryString}`,
//         {
//           headers: {
//             Authorization: `Bearer ${
//               JSON.parse(sessionStorage.getItem("user")).accessToken
//             }`,
//           },
//           responseType: 'blob', // important to get response as blob
//         }
//       );
      
//       // Create a link element
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement('a');
//       link.href = url;
      
//       // Specify the file name
//       link.setAttribute('download', 'activity_log.xlsx');
      
//       // Append to the DOM
//       document.body.appendChild(link);
      
//       // Trigger the download
//       link.click();
      
//       // Clean up and remove the link
//       link.parentNode.removeChild(link);
      
//       // parentFunctionLeads(response.data.data);
//     } catch (error) {
//       console.error("Error filtering activities", error);
//     }
// };


  

// //   try {
// //     const response = await axios.get(
// //       `${Api_Url}api/v1/BusinessPd/generatebusinesspdpdf/${id}`,
// //       {
// //         responseType: "blob", // Important to handle binary data correctly
// //         headers: {
// //           Authorization: `Bearer ${
// //             JSON.parse(sessionStorage.getItem("user"))?.accessToken
// //           }`,
// //         },
// //       }
// //     );

// //     // Create a blob object from the response
// //     const file = new Blob([response.data], { type: "application/pdf" });

// //     // Create a URL for the blob object
// //     const fileURL = URL.createObjectURL(file);

// //     // Create a link element
// //     const link = document.createElement("a");
// //     link.href = fileURL;
// //     link.setAttribute("download", `BusinessPD-${id}.pdf`); // Specify the file name

// //     // Append the link to the body
// //     document.body.appendChild(link);

// //     // Trigger the download
// //     link.click();

// //     // Clean up
// //     URL.revokeObjectURL(fileURL);
// //     document.body.removeChild(link);

// //     SuccessToast("Download Successful");
// //   } catch (error) {
// //     ErrorToast("Something went wrong");
// //   }
// // };

//   return (
//     <>
//       <div className="row filter-row">
//         <div className="col-sm-6 col-md-3">
//           <div
//             className={
//               focusedClientId
//                 ? "input-block form-focus focused"
//                 : "input-block form-focus"
//             }
//           >
//             <Select
//               options={branch.map((b) => ({ value: b.id, label: b.name }))}
//               value={inputValueClientId}
//               onChange={handleBranchChange}
//               onFocus={() => setFocusedClientId(true)}
//               onBlur={() =>
//                 setFocusedClientId(inputValueClientId ? true : false)
//               }
//               placeholder="Select Branch"
//               styles={customStyles}
//             />
//           </div>
//         </div>
//         <div className="col-sm-6 col-md-3">
//           <div
//             className={
//               focusedClientId
//                 ? "input-block form-focus focused"
//                 : "input-block form-focus"
//             }
//           >
//             <Select
//               options={activity.map((a) => ({ value: a.id, label: a.name }))}
//               value={selectedActivity}
//               onChange={handleActivityChange}
//               onFocus={() => setFocusedClientId(true)}
//               onBlur={() => setFocusedClientId(selectedActivity ? true : false)}
//               placeholder="Select Activity"
//               styles={customStyles}
//             />
//           </div>
//         </div>

//         <div className="col-sm-6 col-md-3">
//           <div className="input-block form-focus select-focus">
//             <Select
//               options={teamMembers.map((s) => ({
//                 value: s.id,
//                 label: `${s.firstName} ${s.lastName}`,
//               }))}
//               onChange={handleTeamMembers}
//               placeholder="Select Team Members"
//               styles={customStyles}
//               value={inputSourceTeamMembers}
//             />
//           </div>
//         </div>
//         <div className="col-sm-6 col-md-3">
//           <div className="input-block form-focus select-focus">
//             <DatePicker
//               value={startDate ? moment(startDate) : null}
//               onChange={(date) => setStartDate(date ? date.toDate() : null)}
//               format="DD/MM/YYYY"
//               placeholder="Start Date"
//               className="form-control"
//             />
//           </div>
//         </div>

//         <div className="col-sm-6 col-md-3">
//           <div className="input-block form-focus select-focus">
//             <DatePicker
//               value={endDate ? moment(endDate) : null}
//               onChange={(date) => setEndDate(date ? date.toDate() : null)}
//               format="DD/MM/YYYY"
//               placeholder="End Date"
//               className="form-control"
//             />
//           </div>
//         </div>
//         <div className="col-sm-6 col-md-3">
//           <button
//             className="btn btn-success btn-block w-100"
//             onClick={handleFilterApply}
//           >
//             Apply Filter
//           </button>
//         </div>
//         <div className="col-sm-6 col-md-3">
//           <button
//             className="btn btn-primary btn-block w-100"
//             onClick={handleDownload}
//           >
//             Download
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ActivityFilterPage;
